import Utility from '../Utility/Utility';

let Utl = new Utility();
let language = Utl.getCookie("appLang");

const tagName = ( language === "en" ? "Key name" : "Nombre de etiqueta" );
const enName = ( language === "en" ? "English display" : "Presentar en Inglés" );
const esName = ( language === "en" ? "Spanish display" : "Presentar en Español" );

export const DlgContent  =
        `
        <div class='container-fluid'>
            <form id="appAddTag">
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='row form-group'>
                            <div class='col-lg-4 text-end app-label-input'>
                                `+tagName+`
                            </div>
                            <div class='col-lg-8 text-start mt-3'>
                                <input type='hidden' name='lng_id' id='lng_id' />
                                <input type='text' name='lng_name' id='lng_name' class='form-control' />
                            </div>
                        </div>
                    </div>
                </div>
                <div class='row mt-2'>
                    <div class='col-lg-12'>
                        <div class='row form-group'>
                            <div class='col-lg-4 text-end app-label-input'>
                                `+enName+`
                            </div>
                            <div class='col-lg-8 text-start'>
                                <input type='text' name='lng_description_en' id='lng_description_en' class='form-control' />
                            </div>
                        </div>
                    </div>
                </div>
                <div class='row mt-2'>
                    <div class='col-lg-12'>
                        <div class='row'>
                            <div class='col-md-4 text-end app-label-input'>
                                `+esName+`
                            </div>
                            <div class='col-md-8 text-start'>
                                <input type='text' name='lng_description_es' id='lng_description_es' class='form-control' />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        `;

